import { z } from 'zod';

export const addressFieldsSchema = {
    patientStreet: z
        .string()
        .optional()
        .refine((val) => !val || !val.includes(','), {
            message: 'Commas are not allowed in street address',
        }),
    patientZipCode: z.string().optional(),
    patientCity: z.string().optional(),
    patientState: z.string().optional(),
};

export const requiredAddressFieldsSchema = {
    patientStreet: z
        .string()
        .min(1, 'Street address is required')
        .refine((val) => !val.includes(','), {
            message: 'Commas are not allowed in street address',
        }),
    patientZipCode: z.string().optional(),
    patientCity: z.string().optional(),
    patientState: z.string().optional(),
};

export function formatAddress(data: {
    patientStreet?: string;
    patientCity?: string;
    patientState?: string;
    patientZipCode?: string;
}): string | null {
    const addressParts = [
        data.patientStreet,
        data.patientCity,
        data.patientState && data.patientZipCode
            ? `${data.patientState} ${data.patientZipCode}`
            : data.patientState || data.patientZipCode,
    ].filter(Boolean);
    return addressParts.length > 0 ? addressParts.join(', ') : null;
}

export function parseAddress(address: string | null): {
    patientStreet: string;
    patientZipCode: string;
    patientCity: string;
    patientState: string;
} {
    if (!address) {
        return {
            patientStreet: '',
            patientZipCode: '',
            patientCity: '',
            patientState: '',
        };
    }

    const parts = address.split(',').map((part) => part.trim());

    if (parts.length === 3) {
        const [street, city, stateZip] = parts;
        const stateZipParts = stateZip?.split(' ') || [];
        const state = stateZipParts[0] || '';
        const zip = stateZipParts[1] || '';

        return {
            patientStreet: street || '',
            patientCity: city || '',
            patientState: state,
            patientZipCode: zip,
        };
    }

    return {
        patientStreet: address,
        patientZipCode: '',
        patientCity: '',
        patientState: '',
    };
}
